import React from 'react';

import useKiloGLMRecords from 'hooks/glmFlows/useKiloGLMRecords';

import FlowRecordsModal, { UseRecordsFn } from './FlowRecordsModal';

const ModalKiloGLMRecords = ({
  opened,
  onClose,
  flowId,
  flowLabel,
}: {
  opened: boolean;
  onClose: () => void;
  flowId: string | null;
  flowLabel?: string;
}): JSX.Element => (
  <FlowRecordsModal
    opened={opened}
    onClose={onClose}
    flowId={flowId}
    flowLabel={flowLabel}
    direction='kilo_to_glm'
    useRecords={useKiloGLMRecords as UseRecordsFn}
  />
);

export default ModalKiloGLMRecords;
